<script setup>
import { RouterView} from 'vue-router'
import HeaderBar from './components/HeaderBar.vue'
import FooterBar from './components/FooterBar.vue'
import ScrollTop from './components/ScrollTop.vue'



</script>

<template>
  
  <HeaderBar />
<!-- 
  <RouterView /> -->
  <!-- <router-view v-slot="{ Component }">
        <div>
            <transition name="fade-transform" >
              <component :is="Component" />
            </transition>
        </div>
    </router-view> -->

  <!-- <router-view v-slot="{ Component, route }">
  <transition name="fade-transform" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view> -->
<!-- <router-view /> -->

<router-view v-slot="{ Component }">
  <transition name="fade-transform">
    <component :is="Component" />
  </transition>
</router-view>

<FooterBar />

<ScrollTop />

</template>

<style scoped>
@media (max-width: 600px) {
 
}
</style>
